import * as React from "react"

const SvgMap = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M14.35 21.06 9 19.187l-4.65 1.8a.9.9 0 0 1-.487.062 1.2 1.2 0 0 1-.438-.162.87.87 0 0 1-.313-.338A1 1 0 0 1 3 20.061V6.036q0-.326.188-.575a1.13 1.13 0 0 1 .512-.375L8.35 3.51a2 2 0 0 1 .313-.075 2.2 2.2 0 0 1 .987.075L15 5.386l4.65-1.8a.9.9 0 0 1 .488-.063q.237.038.437.163a.87.87 0 0 1 .313.337q.111.213.112.488v14.025a.93.93 0 0 1-.188.575 1.13 1.13 0 0 1-.512.375l-4.65 1.575q-.15.05-.313.075a2.2 2.2 0 0 1-.987-.075ZM14 18.837v-11.7l-4-1.4v11.7zm2 0 3-1V5.986l-3 1.15v11.7Zm-11-.25 3-1.15v-11.7l-3 1z" />
  </svg>
)
export default SvgMap
